import * as React from 'react';
import { ActionAfterViewObserver } from '@cian/action-after-viewed-component';
import { ErrorLogComponent } from '@cian/error-log-component';
import { isEmpty } from 'ramda';
import { useSelector } from 'react-redux';

import { PricesDynamicsContainer } from './containers/PricesDynamicsContainer';
import { trackRealtyValuationInView } from './tracking';
import { RealtyValuation } from '../../components/RealtyValuation';
import { selectDeveloperValuationData } from '../../selectors/developerValuation';
import { Responsive } from '@cian/ui-kit';
import { RealtyValuationMobileContainer } from './RealtyValuationMobileContainer';
import { RealtyValuationMobile } from '../../components/RealtyValuation/RealtyValuationMobile';
import { useApplicationContext } from '../../utils';

/**
 * График строится chart.js в эффекте без try/catch. Локальный boundary: при ошибке исчезает
 * только блок динамики цен, а не вся карточка застройщика.
 */
export function RealtyValuationContainer() {
  const { logger } = useApplicationContext();
  const realtyValuation = useSelector(selectDeveloperValuationData);

  const isRealtyValuationAvailable = React.useMemo(() => {
    if (!realtyValuation || isEmpty(realtyValuation)) {
      return false;
    }

    return realtyValuation.filters.availableRegionIds.length > 0;
  }, [realtyValuation]);

  if (!isRealtyValuationAvailable) {
    return null;
  }

  return (
    <ErrorLogComponent logger={logger}>
      <ActionAfterViewObserver callback={trackRealtyValuationInView} triggerOnce>
        <>
          <Responsive desktop>
            <RealtyValuation title="Динамика цен" content={<PricesDynamicsContainer />} />
          </Responsive>
          <Responsive phone tablet>
            <RealtyValuationMobile title="Уровень цен" content={<RealtyValuationMobileContainer />} />
          </Responsive>
        </>
      </ActionAfterViewObserver>
    </ErrorLogComponent>
  );
}
